<template>
  <section class="view-container">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <p class="font--m-2">본인인증 확인중입니다</p>
          <v-card class="mt-5 mb-5 py-15" flat>
            <v-card-subtitle class="font--m-4">
              {{ content[index] }}
            </v-card-subtitle>
          </v-card>
          <BasicButton disabled loading v-ripple class="button next-button" type="button">
            적격 여부 확인하기
          </BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      index: 0,
      content: ['정보를 요청하고 있습니다', '잠시만 기다려 주세요', '확인하고 있습니다'],
    }
  },
  created() {
    _meta({
      titles: ['신분증확인'],
    })
    this.rotate()
  },
  watch: {
    index(v) {
      if (v === 2) {
        this.checkResult()
      }
    },
  },
  methods: {
    rotate() {
      setTimeout(() => {
        this.index += 1
        if (this.index >= this.content.length) {
          this.index = 0
        }
        this.rotate()
      }, 3000)
    },
    ...mapActions('kyc', ['getMobileAuthUrlResult']),
    async checkResult() {
      try {
        const data = await this.getMobileAuthUrlResult()
        if (data) {
          await this.$router.replace('/kyc/verify-id/success')
        } else {
          await this.$router.replace('/kyc/verify-id/failure')
        }
      } catch (e) {
        const swal = await this.$swal.fire({
          html: '본인인증을 확인하는데 문제가 발생했습니다',
          icon: 'warning',
          confirmButtonText: '확인',
        })
        if (swal.isConfirmed) {
          this.$router.replace('/signup/step2')
        }
        throw e
      }
    },
  },
}
</script>
